import { Typography } from "@material-ui/core";
import React from "react";
import useStyles from "./Styles";

const CopyrightView = () => {
  const classes = useStyles();

  return (
    <Typography className={classes.copyright} height="5%" variant="caption">
      Copyright © 2021 Mekong River Commision
    </Typography>
  );
};

export default CopyrightView;
